import React, { useState, useEffect } from 'react';
import Footer from '../../layout/Footer';
import { Container, Row, Col, Card, Button, Table, Badge } from 'react-bootstrap';
import FormInputs from '../../../Utils/FormInputs';
// Datatable
import JSZip from 'jszip';
import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import "datatables.net-buttons/js/buttons.html5.js";
import "datatables.net-buttons/js/buttons.print.js";
import $ from "jquery";
import DataTable from 'datatables.net-dt';

// Icons
import Icon from '@mdi/react';
import { mdiFilterCog, mdiFilterOff } from '@mdi/js';

export default function Calendar() {
    // datatable
    DataTable.Buttons.jszip(JSZip);
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    useEffect(() => {
        if (!$.fn.dataTable.isDataTable('#mainDatatableACCalendar')) {
            $('#mainDatatableACCalendar').DataTable({
                dom: "Bflrtip",
                buttons: [
                    {
                        extend: 'excel',
                        className: 'btn btn-outline-secondary',
                        text: '<svg viewBox="0 0 24 24" role="presentation" class="btn-icon me-1"><path d="M14 2H6C4.89 2 4 2.9 4 4V20C4 21.11 4.89 22 6 22H18C19.11 22 20 21.11 20 20V8L14 2M18 20H6V4H13V9H18V20M12.9 14.5L15.8 19H14L12 15.6L10 19H8.2L11.1 14.5L8.2 10H10L12 13.4L14 10H15.8L12.9 14.5Z" style="fill: currentcolor;"></path></svg> Export to Excel'
                    }
                ],
                language: {
                    search: '',
                    searchPlaceholder: "Search...",
                    paginate: {
                        previous: '«',
                        next: '»'
                    },
                }
            });
        }

        if (document.getElementsByClassName("dt-buttons").length) {
            document.getElementById("mainDatatableACCalendar_wrapper").classList.add("dtl-right");
        } else {
            document.getElementById("mainDatatableACCalendar_wrapper").classList.remove("dtl-right");
        }
    }, []);

    const initialInputData = {
        select_providers: '',
        select_main_status: '',
        select_child_status: '',
        select_category: '',
        select_services: '',
        select_gender: '',
        customer_name: '',
    }

    const [inputData, setInputData] = useState(initialInputData);
    const handleCalendarChange = (index, field, value) => {
        setInputData({ ...inputData, [field]: value });
    };
    const handleCalendarSubmit = (e) => {
        e.preventDefault();
    };
    const calendarRows = [
        {
            columns: [
                {
                    size: { sm: 6, xl: 3 }, label: 'Select Providers', type: 'select', name: 'select_providers', id: 'selectProviders', value: inputData.select_providers, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 3 }, label: 'Select Main Status', type: 'select', name: 'select_main_status', id: 'selectMainStatus', value: inputData.select_main_status, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 3 }, label: 'Select Child Status', type: 'select', name: 'select_child_status', id: 'selectChildStatus', value: inputData.select_child_status, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, xl: 3 }, label: 'Select Category', type: 'select', name: 'select_category', id: 'selectCategory', value: inputData.select_category, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, md: 4 }, label: 'Select Services', type: 'select', name: 'select_services', id: 'selectServices', value: inputData.select_services, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { sm: 6, md: 4 }, label: 'Select Gender', type: 'select', name: 'select_gender', id: 'selectGender', value: inputData.select_gender, errormsg: '',
                    options: [
                        { value: '', label: 'All' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
                {
                    size: { md: 4 }, label: 'Customer Name', type: 'select', name: 'customer_name', id: 'customerName', value: inputData.customer_name, errormsg: '',
                    options: [
                        { value: '', label: 'Select Customer Name' }, { value: '1', label: 'One' }, { value: '2', label: 'Two' },
                        // ...PaymentModes && PaymentModes.map((data) => ({ value: data.id, label: data.name }))
                    ],
                },
            ]
        },
    ];
    const calendarButtons = [];

    return (
        <>
            <div className="page-wrapper">
                <div className='page-content'>
                    <Container>
                        <Row>
                            <Col>
                                <Card>
                                    <Card.Body>
                                        <div className="d-sm-flex justify-content-between align-items-center mb-3">
                                            <Card.Title className='mb-sm-0'>Calendar Report</Card.Title>

                                            <div className="btn-list">
                                                <Button variant="primary"><Icon path={mdiFilterCog} className="btn-icon me-1" /> Filter</Button>{' '}
                                                <Button variant="outline-dark"><Icon path={mdiFilterOff} className="btn-icon me-1" /> Clear Filters</Button>{' '}
                                            </div>
                                        </div>

                                        <FormInputs Buttons={calendarButtons} rows={calendarRows} handleInputChange={handleCalendarChange} handleSubmit={handleCalendarSubmit} />

                                        <Card className='border shadow-none mb-0'>
                                            <Card.Body>
                                                <Card.Title>Transaction Data Info</Card.Title>
                                                <Table responsive bordered className='table-nowrap' id='mainDatatableACCalendar'>
                                                    <thead className='table-light'>
                                                        <tr>
                                                            <th>Customer</th>
                                                            <th>Gender</th>
                                                            <th>Date</th>
                                                            <th>Category</th>
                                                            <th>Service</th>
                                                            <th>Provider Name</th>
                                                            <th>Status</th>
                                                            <th>Reason</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td>Hiram G. Salazar</td>
                                                            <td>Male</td>
                                                            <td>28/12/2022</td>
                                                            <td>Invoice</td>
                                                            <td>Service</td>
                                                            <td>Patel Mall</td>
                                                            <td> <Badge bg="soft-success">Delivered</Badge></td>
                                                            <td>Service</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </Card.Body>
                                        </Card>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </>
    )
}
